<template  id="template-input-data">
  <div v-if="info_page.status_page=='input'" id="input-data">
    <!-- <div class="section-header" ></div> -->
    <header-section :title='"Đăng ký làm Cố vấn"'></header-section>
    <div class="section-form container">
    
      <div class="information section-element">
        <h3>Thông tin cá nhân</h3>
        <div class="row">
          <div class="name col-md-6">
            <span> Tên của bạn <span style="color:red">*</span>               
            </span>
            <input v-model='info_page.user_info.name' type="text" name="" class="form-control" placeholder="Họ và tên đầy đủ của bạn">
            <small class="required_field" v-if="has_errors('name')">{{this.info_page.errors['name']}}</small>
          </div>
          <div class="email col-md-6">
            <span>Email <span style="color:red">*</span>              
            </span>
            <input v-model='info_page.user_info.email' type="text" name="" class="form-control" placeholder="you@yourdomain.com">
            <small class="required_field"v-if="has_errors('email')">{{this.info_page.errors['email']}}</small>
          </div>              
          <div class="date-of-birth col-md-6">
            <span>Ngày tháng năm sinh <span style="color:red">*</span>            
          </span>
            <input v-model='info_page.user_info.date_of_birth' type="date" data-input="true" name="" class="form-control datepicker flatpickr-input" placeholder="dd/mm/yy">
            <small class="required_field"v-if="has_errors('date_of_birth')">{{this.info_page.errors['date_of_birth']}}</small>
          </div>
          <div class="address col-md-6">
            <span>Nơi đang sinh sống <span style="color:red">*</span>              
            </span>
            <input v-model='info_page.user_info.address' type="text" name="" class="form-control" placeholder='Ví dụ như "Hanoi, Vietnam," "New York, NY"'>
            <small class="required_field"v-if="has_errors('address')">{{this.info_page.errors['address']}}</small>
          </div>
          <div class="phone-number col-md-6">
            <span>Số điện thoại <span style="color:red">*</span>              
            </span>
            <input v-model='info_page.user_info.phone' type="tel" name="" class="form-control" placeholder="">
            <small class="required_field"v-if="has_errors('phone')">{{this.info_page.errors['phone']}}</small>
          </div>
          <div class="candidate-title col-md-6">
            <span>Chức danh <span style="color:red">*</span>              
            </span>
            <input v-model='info_page.user_info.counselor_title' type="text" name="" class="form-control" placeholder='Ví dụ như "Web Developer, Mora Technology"'>
            <small class="required_field"v-if="has_errors('counselor_title')">{{this.info_page.errors['counselor_title']}}</small>
          </div>
          <div class="linkedin col-md-6">
            <span>LinkedIn</span>
            <input v-model='info_page.user_info.linkedin' type="text" name="" class="form-control" placeholder="your linkedIn page link">
          </div>
          <div class="educate-level col-md-6">
            <span>Trình độ học vấn cao nhất <span style="color:red">*</span>              
            </span>
            <multiselect 
              v-model='info_page.user_info.level_education' 
              :options="level_educations" 
              placeholder="Chọn trình độ học vấn" 
              :allow-empty="false"
              :show-labels="false">              
            </multiselect> 
            <small class="required_field"v-if="has_errors('level_education')">{{this.info_page.errors['level_education']}}</small>
          </div>
          <div class="avatar-user col-md-6">
            <span>Ảnh đại diện <span style="color:red">*</span></span>
            <input accept="image/*" v-on:change="upload_file" type="file" class="form-control" placeholder="">
          </div>
          <div class="resume-category col-md-6">
            <span>Dịch vụ bạn muốn cung cấp <span style="color:red">*</span>              
            </span>
            <multiselect
              v-model="info_page.user_info.available_service"
              :options="list_services"
              :multiple='true'
              :taggable="true" 
              @tag="addTag"
              :close-on-select="true"
              placeholder='Chọn dịch vụ'          
              label="name"
              track-by="name"
            ></multiselect>
            <small class="required_field"v-if="has_errors('level_education')">{{this.info_page.errors['level_education']}}</small>
            <!-- <pre class="language-json"><code>{{info_page.user_info.available_service}}</code></pre> -->
          </div>
        </div>            
      </div>
      <div class="education section-element">
        <h3>Bằng cấp <span style="color:red">*</span></h3>
        <small class="required_field" v-if="has_errors('degree')">{{info_page.errors['degree']}}</small>
        <div class="">
          <div v-for="(de, index) in info_page.user_info.degree" :key="index">
            <div class="row">
              <div class="col-md-12"></div>
              <div class="col-md-6">
                <span>Trường <span style="color:red">*</span>                  
                </span>                
                <input v-model='de.university' type="text" class="form-control">
                <small class="required_field" v-if="has_errors('missing_field_ed')">{{info_page.errors['missing_field_ed']}}</small>
              </div>

              <div class="col-md-6">
                <span>Chuyên ngành <span style="color:red">*</span></span>
                <div class="remove-button" @click="remove_element('degree',index)"> remove</div>
                <input v-model='de.major' type="text" class="form-control">
                <small class="required_field" v-if="has_errors('missing_field_ed')">{{info_page.errors['missing_field_ed']}}</small>
              </div>
              <div class="col-md-6">
                <span>Ngày bắt đầu <span style="color:red">*</span>                  
                </span>
                <input v-model='de.start_date' type="date" class="form-control">
                <small class="required_field"v-if="has_errors('missing_field_ed')">{{info_page.errors['missing_field_ed']}}</small>
              </div>
              <div class="col-md-6">
                <span>Ngày kết thúc</span>
                <input v-model='de.end_date' type="date" class="form-control">
              </div>
            </div>              
          </div>
          <button class="btn btn-default" @click="add_element('degree')">+ Thêm bằng cấp</button>
        </div>
      </div>
      <div class="results-exam section-element">
        <h3>Điểm bài thi chuẩn hóa</h3>
        <div class="row">
          <div v-for="(value, key, index) in info_page.user_info.score" class="col-md-6">
            <small>{{key.toUpperCase()}}</small>
            <input v-model="info_page.user_info.score[key]" type="number" class="form-control">
          </div>
        </div>
      </div>
      <div class="experience section-element">
        <h3>Kinh nghiệm làm việc</h3>
        <div class="">
          <div v-for="(ex, index) in info_page.user_info.experience" :key="index">
            <div class="row">
              <div class="col-md-12"></div>
              <div class="col-md-6">
                <span>Công ty <span style="color:red">*</span></span>
                <input v-model='ex.company' type="text" class="form-control">
                <small class="required_field" v-if="has_errors('missing_field')">{{info_page.errors['missing_field_ex']}}</small>
              </div>
              <div class="col-md-6">
                <span>Vị trí <span style="color:red">*</span></span>
                <div class="remove-button" @click="remove_element('experience',index)"> remove</div>
                <input v-model='ex.major' type="text" class="form-control">
                <small class="required_field" v-if="has_errors('missing_field')">{{info_page.errors['missing_field_ex']}}</small>
              </div>
              <div class="col-md-6">
                <span>Ngày bắt đầu <span style="color:red">*</span></span>
                <input v-model='ex.start_date' type="date" class="form-control">
                <small class="required_field" v-if="has_errors('missing_field')">{{info_page.errors['missing_field_ex']}}</small>
              </div>
              <div class="col-md-6">
                <span>Ngày kết thúc</span>
                <input v-model='ex.end_date' type="date" class="form-control">
              </div>
            </div>              
          </div>
          <button class="btn btn-default" @click="add_element('experience')">+ Thêm kinh nghiệm</button>
        </div>
      </div>
      <div class="introduce-yourself section-element">
        <h3>Giới thiệu bản thân <span style="color:red">*</span></h3>
        <textarea v-model="info_page.user_info.introduce" class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Write a large text here ..."></textarea>  
      </div>
      <!-- <div v-if="has_errors('degree')" class="alert alert-warning" role="alert">
        <strong>Chú ý!</strong> {{info_page.errors['degree']}}
      </div> -->
      <div class="button-group">
        <button id="preview-button" @click="$parent.set_status('preview'); validate_require_field($event); update_data;" class="btn btn-default"> Xem thử </button>
        <!--  -->
      </div>
    </div>
  </div>  
</template>
<script>
  // import Multiselect from 'vue-multiselect'
  import Multiselect from 'vue-multiselect'
  import { mapState, mapActions } from 'vuex'
  import HeaderSection from "../Common/HeaderSection.vue"

  var list_field_required = ['name', 'email', 'date_of_birth', 'address', 'phone', 'level_education', 'counselor_title', 'level_education', 'available_service']
  var required_field_in_education = ['university', 'major', 'start_date']
  var required_field_in_experience = ['company', 'major', 'start_date']
  var url = process.env.API_URL + process.env.API_VERSION

  export default{
    props: ['info_page'],
    components: {
      HeaderSection,
      Multiselect
    },
    data: function(){
      return {
        level_educations:[
          'Phổ thông', 'Đại học', 'Thạc sĩ', 'Tiến sĩ'
        ]
        // list_service: []
      }
    },
    computed: mapState('services', {
      list_services: state => state.list_services
    }),

    created: function(){
      this.$store.dispatch('services/load_list_services');
    },    
    methods: {
      // sync data with parent component
      update_data: function(){
        // this.info_page['user_info']['name']=this.info_page.user_info
        // alert(typeof(this.info_page.user_info.degree));
        this.$emit('updateData', this.info_page)        
      },
      // upload file avatar image
      upload_file: function(event){
        var input = event.target;
        if (input.files && input.files[0]){
            var reader = new FileReader();
            reader.onload = (e) => {
              this.info_page.user_info.avatar_file = input.files[0]
              this.info_page.user_info.avatar = e.target.result
              this.$emit('updateData', this.info_page)
            }
            reader.readAsDataURL(input.files[0]);           
        }
      },
      add_element: function(ele){
        this.info_page.user_info[ele].push({})
      },
      remove_element: function(ele, index){
        this.info_page.user_info[ele].splice(index,1);
      },
      validate_require_field: function(event){
        for (var field in list_field_required){
          if (  this.info_page.user_info[list_field_required[field]] == '' || 
                this.info_page.user_info[list_field_required[field]].length <= 0) {
            this.info_page.errors[list_field_required[field]] = 'Trường bắt buộc';
            // alert(this.info_page.errors[list_field_required[field]] + list_field_required[field]);
          }else{
            delete this.info_page.errors[list_field_required[field]];
          }
        }

        if (this.info_page.user_info['experience'].length > 0){
          this.info_page.user_info['experience'].forEach((ex) =>{
            required_field_in_experience.forEach((field) =>{
              if (ex[field] == '' || ex[field] == undefined){
                this.info_page.errors['missing_field_ex'] = 'Trường bắt buộc'
                checker = false
              }
            })
          });
          if (checker){
            delete this.info_page.errors['missing_field_ex'];
          }
        }

        if (this.info_page.user_info['degree'].length <= 0){
          this.info_page.errors['degree'] = 'Phải có ít nhất 1 bằng cấp';          
          // alert(this.info_page.errors['degree']);
        }else
        {
          delete this.info_page.errors['degree'];

          var checker = true
          this.info_page.user_info['degree'].forEach((de) =>{
            required_field_in_education.forEach((field) =>{
              if (de[field] == '' || de[field] == undefined){
                this.info_page.errors['missing_field_ed'] = 'Trường bắt buộc'
                checker = false
              }
            })
          });
          if (checker){
            delete this.info_page.errors['missing_field_ed'];
          }
          // for (var de in this.info_page.user_info['degree']){
          //   for (var key in required_field_in_education){
          //     if this.info_page.user_info['degree'][de][requ]
          //   }
          // }                    
        }

        if (Object.keys(this.info_page.errors).length > 0 ){
          this.info_page.status_page = 'input';
          alert('Yêu cầu điền đầy đủ các trường thông tin bắt buộc')
        }
      },
      //return false if this field empty
      has_errors: function(field_name){        
        if (this.info_page.errors[field_name] != 'undefined' && this.info_page.errors[field_name]!='')
        {
          return true;
        }  
        return false;
      },
      updateSelected: function (newSelected) {
        this.info_page.user_info.available_service = newSelected
      },
      addTag (newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
        }        
        this.options.push(tag)
        this.value.push(tag)
      }

    }
  };
</script>
<style lang="scss" scoped>
  @import "./input_data"

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/views/components/RegisterPage/InputData.vue